import { render, staticRenderFns } from "./FavoriteLine.vue?vue&type=template&id=53faddd5"
import script from "./FavoriteLine.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteLine.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports